import { useUIStore } from '../../stores/uiStore';

export default function StreakToast() {
  const { streakToastText, streakToastVisible } = useUIStore();

  return (
    <div
      className={`streak-toast${streakToastVisible ? ' show' : ''}`}
    >
      {streakToastText}
    </div>
  );
}
